module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.tree !== null) ? _c('h2', [_vm._v("Award - " + _vm._s(_vm.awardIndex + 1))]) : _vm._e(), _vm._v(" "), (_vm.tree !== null && _vm.awardIndex > 0) ? _c('div', {
    staticStyle: {
      "margin-top": "-48px",
      "margin-left": "120px",
      "margin-bottom": "30px"
    },
    on: {
      "click": function($event) {
        return _vm.removeTheAward()
      }
    }
  }, [_c('icon-tooltip', {
    attrs: {
      "tooltip-name": "period-delete",
      "tooltip-text": "To delete this award just select this icon.",
      "side": "right",
      "text-width": "200",
      "icon-type": "delete",
      "icon-colour": "m-icon--dark"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.tree !== null) ? _c('injury-select', {
    attrs: {
      "tree": _vm.tree,
      "selected": _vm.selected,
      "awardIndex": _vm.awardIndex,
      "level": 0
    },
    on: {
      "injury-selected": _vm.selectedInjury,
      "award-selected": _vm.selectedAward
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    class: {
      'a-loader--generalDamages': _vm.tree === null
    }
  }), _vm._v(" "), (_vm.tree !== null && _vm.award.generalDamages) ? _c('hr') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3c4660b9!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/personal-injury-claims/steps/awards/Award.vue
// module id = 1650
// module chunks = 0